import { Notifications } from '@intigral/shared';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import OverlayPortal from '../components/elements/OverlayPortal';
import Popup from '../components/elements/Popup';
import RefreshTokenErrorDialog from '../components/RefreshTokenErrorDialog';
import { RouteCondition, RouteGuard } from './guard';
import { UserStatus } from '../components/ui/UserStatus';
import { Footer } from './Footer';
import { MobileTabBar } from './MobileTabBar';
import GenesysChatbox from '../components/ui/Genesys';
import { Header } from '../features';
import { AppThemeOverlay } from '../features/app-theme/AppThemeOverlay';

const MenuLayout = ({ conditions, context }: { conditions: RouteCondition[]; context: any }) => {
    return (
        <RouteGuard conditions={conditions} context={context}>
            <Suspense fallback={null}>
                <Header />
            </Suspense>
            <AppThemeOverlay />
            <Outlet />
            <Footer />
            <MobileTabBar />
            <Popup />
            {/* will refactor OverlayPortal */}
            <OverlayPortal />
            <RefreshTokenErrorDialog />
            <Notifications />
            <GenesysChatbox />
            <UserStatus />
        </RouteGuard>
    );
};

export default MenuLayout;
